import { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/lib/query-client';
import { MotionProvider } from '@/providers/motion-provider';
import { ThemeProvider } from '@/providers/theme-provider';

/** Composition root for app-wide providers (theme, data-fetching, motion, ...). */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider defaultTheme="light">
      <QueryClientProvider client={queryClient}>
        <MotionProvider>{children}</MotionProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
